export default "__VITE_ASSET__BZFtVmw9__"